export function ArrowRight() {
  return (
    <svg width='19' height='16' viewBox='0 0 19 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 8.00063C0 7.69756 0.120396 7.4069 0.334701 7.19259C0.549007 6.97829 0.839667 6.85789 1.14274 6.85789H14.3825L9.47561 1.95325C9.26103 1.73867 9.14049 1.44764 9.14049 1.14418C9.14049 0.840728 9.26103 0.5497 9.47561 0.335124C9.69019 0.120548 9.98121 0 10.2847 0C10.5881 0 10.8792 0.120548 11.0937 0.335124L17.9502 7.19157C18.0566 7.29772 18.141 7.42382 18.1986 7.56266C18.2562 7.70149 18.2859 7.85032 18.2859 8.00063C18.2859 8.15094 18.2562 8.29977 18.1986 8.43861C18.141 8.57744 18.0566 8.70354 17.9502 8.80969L11.0937 15.6661C10.8792 15.8807 10.5881 16.0013 10.2847 16.0013C9.98121 16.0013 9.69019 15.8807 9.47561 15.6661C9.26103 15.4516 9.14049 15.1605 9.14049 14.8571C9.14049 14.5536 9.26103 14.2626 9.47561 14.048L14.3825 9.14337H1.14274C0.839667 9.14337 0.549007 9.02298 0.334701 8.80867C0.120396 8.59437 0 8.3037 0 8.00063Z'
        fill='white'
      />
    </svg>
  );
}
